import { render, staticRenderFns } from "./OrdenesProduccion.vue?vue&type=template&id=89272c32&"
import script from "./OrdenesProduccion.vue?vue&type=script&lang=js&"
export * from "./OrdenesProduccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports